import { useMutation } from "@apollo/client";
import { Button, Grid, MenuItem, Paper, TextField } from "@mui/material";
import React from "react";
import * as Yup from "yup";
import {
  AGREGAR_CONCEPTOBANCARIO,
  LISTAR_SUBTIPO_EGRESOS,
} from "../../../../graphql/bancos";
import { useFormik } from "formik";
const FrmAgregarConceptoBanco = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  const [agregarConceptoBanco] = useMutation(AGREGAR_CONCEPTOBANCARIO, {
    update(cache, { data: { agregarConceptoBanco } }) {
      const { obtenerConceptoBancos } = cache.readQuery({
        query: LISTAR_SUBTIPO_EGRESOS,
      });
      cache.writeQuery({
        query: LISTAR_SUBTIPO_EGRESOS,
        data: {
          obtenerConceptoBancos: [
            ...obtenerConceptoBancos,
            agregarConceptoBanco,
          ],
        },
      });
    },
  });

  const formik = useFormik({
    initialValues: {
      concepto: "",
      TipoConceptoId: "",
    },
    validationSchema: Yup.object({
      concepto: Yup.string().required("El concepto es requerido"),
    }),
    onSubmit: async (inputdata) => {
      try {
        const result = await agregarConceptoBanco({
          variables: {
            input: {
              concepto: inputdata.concepto,
              TipoConceptoId: parseInt(inputdata.TipoConceptoId),
            },
          },
        });
        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.agregarConceptoBanco,
          severity: "success",
        });
        //Si todo sale bien reseteamos el formulario
        formik.resetForm();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };
  return (
    <form onSubmit={formik.handleSubmit}>
      <Paper style={{ paddin: 10 }}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item xs={12}>
            <TextField
              id="concepto"
              label="Concepto"
              name="concepto"
              variant="standard"
              value={formik.values.concepto}
              onChange={formik.handleChange}
              fullWidth
            />
            {formik.errors.concepto}
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              select
              fullWidth
              name="TipoConceptoId"
              id="TipoConceptoId"
              label="Tipo de Concepto"
              variant="standard"
              onChange={formik.handleChange}
              value={formik.values.TipoConceptoId}
            >
              <MenuItem value="1">Ingreso</MenuItem>
              <MenuItem value="2">Egreso</MenuItem>
            </TextField>
            {formik.errors.TipoConceptoId}
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <Button type="submit">Guardar</Button>
            <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};

export default FrmAgregarConceptoBanco;
